module.exports = __webpack_public_path__ + "static/media/preview.328cf8a9.svg";